import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/timeout';
import 'rxjs/add/operator/retry';
import 'rxjs/add/operator/delay';
import { NgxSpinnerService } from "ngx-spinner";
import { SharedService } from './shared.service';
import { CatalogoDetalleBean } from 'src/app/_beans/CatalogoDetalleBean';

@Injectable({
  providedIn: 'root'
})
export class RestProviderService {
  timeout: number = 60; // seconds
  constructor(
    private spinner: NgxSpinnerService,
    private http: HttpClient,
    public sharedService: SharedService,
  ) {
  }
  public listarCatalogoDetallePorIdCatalogo(idCatalogo: number, cadalogoDetalleList: CatalogoDetalleBean[]): Promise<any> {
    let params = {
      data: {
        id: idCatalogo
      }
    }
    return new Promise((resolve, reject) => {
      this.executeHttpMethod("/cdc/bic", params).subscribe((result: any) => {
        result.datalist.forEach(catalog => {
          cadalogoDetalleList.push(catalog);
        });
        resolve("success");
      }, error => {
        reject("error");
        console.error(error);
      });
    });
  }

  public calcularAvanceDesdePrimerNivel(objetivo: any) {
    if (objetivo) {
      return new Promise((resolve, reject) => {
        this.executeHttpMethod("/oc/capn", { data: objetivo }).subscribe((result: any) => {
          resolve("success");
        });
      });
    }else{
      return new Promise((resolve, reject) => {
        resolve("success");
      });
    }
  }

  public executeHttpMethod(method: string, params: any, fileUploadMode?: boolean) {
    let headers = new HttpHeaders();
    let timeout = this.timeout * 1000;
    let requestParams: any;
    if (fileUploadMode) {
      timeout = timeout * 5;
      requestParams = params;
    } else {
      headers = headers.set('Content-Type', 'application/json');
      requestParams = JSON.stringify(params)
    }
    headers = headers.set('Authorization', 'Bearer ' + this.sharedService.sessionKey);

    let requestOptions: any = {
      headers: headers,
      responseType: 'json' // arraybuffer || blob || json(default) || text
    };
    this.spinner.show();
    return this.http
      .post(this.sharedService.ServerURL + method, requestParams, requestOptions).timeout(timeout).map(response => {
        this.spinner.hide();
        let result: any = response;

        if(result == undefined){
          throw new Error('Uncontrolled exception');
        }

        if (result.responseCode == '0') {
          throw new Error(result.messageErrors);
        }

        return result;
      })
      .catch(this.handleError.bind(this));
  }

  private handleError(response: Response | any) {
    if (this.spinner)
      this.spinner.hide();
    console.error('handleError : ' + response);
    console.error('handleError : ' + JSON.stringify(response));
    let errMsg: string = 'unknown exception';
    if (response instanceof Response) {
      const body: any = response.json() || '';
      const err = body.error || JSON.stringify(body);
      errMsg = `${response.status} - ${response.statusText || ''} ${err}`;
    } else {
      if (response) {
        if (response && response.error) {
          errMsg = response.error.error;
        } else {
          errMsg = response.message ? response.message : response.toString();
        }
      }
    }
    if (errMsg == "Unauthorized") {
      setTimeout(() => {
        window.location.href = '/';
      }, 2500);
    }
    return Observable.throw(errMsg);
  }

  public getFile(method: string, params?: any): Observable<any> {
    params = params != undefined ? params : {};
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    headers = headers.set('Authorization', 'Bearer ' + this.sharedService.sessionKey);
    let timeout = 60;//seconds
    this.spinner.show();
    return this.http
      .post(this.sharedService.ServerURL + method, JSON.stringify(params), { headers: headers, responseType: "arraybuffer" }).timeout(timeout * 1000).map(response => {
        this.spinner.hide();
        let result: any = response;
        return result;
      })
      .catch(this.handleError.bind(this));
  }

}
